import { createRoot } from "react-dom/client";
import { App } from "./proto/App";
import { reportWebVitals } from "./reportWebVitals";
import { unregister } from "./serviceWorker";

const root = createRoot(document.getElementById("root"));
root.render(<App />);
unregister();
reportWebVitals();
